import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import classnames from 'classnames';
import ToastDefault from "../FieldComponets/Toast";
import LogoImg from '../../assets/images/hroselylogo.jpg';
import LogoBlack from '../../assets/images/main-logo-black.svg';
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
// import LogoImg from '../../assets/images/hroselylogo.jpg';
import { ResetPasswordAction, AdminResendOtpAction } from "../../Redux/Action/AuthAction";
import { APP_DEVELOPED_BY, APP_NAME, BASE_URL, url } from "../../Config/Config";
import { validateFields } from "../../utils/Validation";
import { getItemFromStorage } from "../../utils/Helper";
import { StorageConstant } from "../../Constants/Constants";
import { FormattedMessage, useIntl } from "react-intl";
// const LogoImg = require('../../assets/images/hroselylogo.jpg')
// const LogoImgs = require('../../assets/images/logo.png')
const LogoImgs = require('../../assets/images/loginLogo.jpg')
const Logo  = require("../../assets/images/newLogo.png")
interface FormInputs {
    password: any,
    otp: number
}
function ResetPassword() {
    const dispatch = useDispatch<any>();
    const intl = useIntl();
    let navigate = useNavigate();
    const location = useLocation()
    const [isOtpVerified, setIsOtpVerified]: any = useState(false)
    const [passwordType, setPasswordType] = useState(false);
    const [confirmPasswordType, setConfirmPasswordType] = useState(false);
    const [validation, setValidation] = useState({
        new_passwordError: '',
        confirm_passwordError: ''
    })


    const [forgetData, setForgetData]: any = useState({
        password: "",
        confirm_password: "",
        otp: "",
        email: ''
    });

    
    const handleForgetData = (e: any) => {
        setValidation({ new_passwordError: '', confirm_passwordError: '' });

        setForgetData({ ...forgetData, [e.target.name]: e.target.value });
    };
    const { register, formState: { errors }, handleSubmit, watch, reset } = useForm<FormInputs>();
    const reset_password = useSelector((state: any) => state.ResetPasswordState)


    const [otpData,setOtpData] = useState(0)
    const onSubmit = (data: FormInputs) => {
        const dataToSend = {
            ...data,
            email: location.state,
            verify_type: 'otp_verify'
        };
        setOtpData(data?.otp)
        dispatch(ResetPasswordAction(dataToSend));
        reset()
    };


    useEffect(() => {
        if (reset_password?.status === true) {
            setIsOtpVerified(true)
            if (isOtpVerified == true) {
                setTimeout(function () {
                    window.location.href = BASE_URL + '/'
                }, 800)
            }
        }
        if (getItemFromStorage(StorageConstant?.is_admin_login_token) !== null) {
            setTimeout(function () {
                navigate(url + '/dashboard')
            }, 900)
        }
    }, [reset_password?.status, reset_password?.loading]);
    useEffect(() => {
        if (reset_password?.error) {
            setValidation({
                ...validation, new_passwordError: reset_password?.error?.password?.message as string, confirm_passwordError: reset_password?.error?.confirm_password?.message as string
            })
        }
    }, [reset_password?.error]);

    useEffect(() => {
        if (location.state === null)
            window.location.href = BASE_URL + '/'
    }, [])

    const handleSubmits = (e: any) => {
        e.preventDefault();

        forgetData.email = location.state
        forgetData.otp = otpData
        const new_passwordError = validateFields.validatePassword(forgetData.password);
        const confirm_passwordError = validateFields.validateConfirmPassword(forgetData.password, forgetData.confirm_password);

        if ([new_passwordError, confirm_passwordError].every(e => e === false)) {
            setValidation({
                ...validation, new_passwordError: new_passwordError as string, confirm_passwordError: confirm_passwordError as string
            })
            dispatch(ResetPasswordAction(forgetData))
        }
        else {
            setValidation({
                ...validation, new_passwordError: new_passwordError as string, confirm_passwordError: confirm_passwordError as string
            })
        }

    };
    const [time, setTime] = useState(59); // Initial time set to 59 seconds
    const [timeData, setTimeData] = useState(false)


    const handletime = (e: any) => {
        setTimeData(false)
        setTime(59);
        let payload = {
            email: location.state,
            otp_type: "FORGOT_PASSWORD"
        }

        dispatch(AdminResendOtpAction(payload))
    }

    useEffect(() => {
        let countdown = setInterval(() => {
            setTime(prevTime => {
                if (prevTime > 0) {
                    return prevTime - 1; // Decrease time by 1 second
                } else {
                    setTimeData(true);
                    clearInterval(countdown); // Stop the timer when time reaches 0
                    return 0;
                }
            });
        }, 1000); // 1000 milliseconds = 1 second

        return () => clearInterval(countdown);
    }, [time]);

    useEffect(() => {
        return () => {
            dispatch({ type: "RESET_PASSWORD_RESET" })
        }
    }, [])

    return (
        <Fragment>
            {reset_password?.loading ? <Spinner /> : ""}
            <div className="auth-body-bg">
                <div className=" container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-xl-3">
                            <div className="auth-full-page-content p-md-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5">

                                            <Link to="/" style={{width: '170px'}} className="mx-auto d-flex justify-content-center auth-logo">
                                                <img className="w-100" src={Logo} alt="image" />
                                            </Link>

                                        </div>
                                        <div className="my-auto">

                                            <div>
                                                <h5 className="theme-color"> <FormattedMessage id="reset_password" /></h5>
                                                <p className="text-muted"><FormattedMessage id="reset_password_with" values={{ appName: APP_NAME }} /></p>
                                            </div>

                                            <div className="mt-4">
                                                {/* <div className="alert alert-success text-center mb-4" role="alert">
                                                    Enter your new password!
                                                </div> */}
                                                {isOtpVerified == true ?
                                                    <form className="form-horizontal" onSubmit={handleSubmits} >
                                                        <div className="mb-3">
                                                            <label htmlFor="new_password" className="form-label"><FormattedMessage id="password" /></label>
                                                            <div className="input-group auth-pass-inputgroup">
                                                                <input name="password" type={passwordType ? "text" : "password"} className={classnames("form-control input-border-bottom m-0",)} value={forgetData.password} onChange={handleForgetData} placeholder={intl.formatMessage({ id: "enter_password" })} />
                                                                <button className="btn btn-light " type="button" onClick={() => { setPasswordType(!passwordType); }} ><i className={`${passwordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                            </div>
                                                            <p className="text-danger">{validation.new_passwordError}</p>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="confirm_password" className="form-label"><FormattedMessage id="confirm_password" /></label>
                                                            <div className="input-group auth-pass-inputgroup">
                                                                <input className={classnames("form-control input-border-bottom m-0",)} name="confirm_password" type={confirmPasswordType ? "text" : "password"} value={forgetData.confirm_password} onChange={handleForgetData} placeholder={intl.formatMessage({ id: "confirm_password" })} />
                                                                <button className="btn btn-light " type="button" onClick={() => { setConfirmPasswordType(!confirmPasswordType); }} ><i className={`${confirmPasswordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                                {/* <div className="show-password">
                                                        <i className="icon-eye"></i>
                                                    </div> */}
                                                            </div>
                                                            <p className="text-danger">{validation.confirm_passwordError}</p>
                                                        </div>
                                                        <div className="text-end">
                                                            <button className="btn theme-bg text-white w-md waves-effect waves-light" type="submit"><FormattedMessage id="reset" /></button>
                                                        </div>
                                                    </form>
                                                    : <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)} >

                                                        <div className="mb-3">
                                                            <label className="form-label"><FormattedMessage id="otp_verification" /></label>
                                                            <div className="input-group auth-pass-inputgroup">
                                                                <input
                                                                    type="text" className="form-control" maxLength={4} placeholder={intl.formatMessage({ id: "enter_otp" })} aria-label="Otp" aria-describedby="otp-addon" {...register("otp", { required: intl.formatMessage({ id: "please_enter_otp" }) })} onInput={(e: any) => {
                                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                    }} />
                                                            </div>
                                                            <ErrorMessage
                                                                errors={errors}
                                                                name="otp"
                                                                render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
                                                            />
                                                        </div>
                                                        <div className="d-flex">


                                                            <div className="">
                                                                {
                                                                    timeData == true &&
                                                                    <button className="btn theme-bg text-white w-md waves-effect waves-light" type="submit" onClick={(e: any) => handletime(e.target.value)}><FormattedMessage id="resend_otp" /></button>

                                                                }
                                                                  {time > 0 ? 
                                                                <p className="mt-2 mb-0"><FormattedMessage id="time_left" values={{ seconds: time }} /></p>
                                                                      : null}

                                                            </div>
                                                            <div className="ms-auto">
                                                                <button className="btn theme-bg text-white w-md waves-effect waves-light" type="submit"><FormattedMessage id="reset" /></button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                }
                                                <div className="mt-5 text-center">
                                                    <p><FormattedMessage id="remember_it" /> <Link to={url + '/'} className="fw-medium theme-color"> <FormattedMessage id="sign_in_here" /></Link> </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-4 mt-md-5 text-center">
                                            <p>© <script>document.write(new Date().getFullYear())</script> {APP_NAME}. Crafted by {APP_DEVELOPED_BY}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9 horselylogo">
                            <img src={LogoImgs} alt="image" />

                        </div>
                    </div>
                </div>
            </div>
            <ToastDefault />
        </Fragment>
    );
}

export default ResetPassword;